import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
  Alert
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import { useDialplanNodeContext } from "./DialplanNode";
import { NODES } from "./Nodes";
import { AgentBringYourOwnVariant } from "./AgentNode";
import { useProfile } from "../../repository/ProfileRepository";

const BASE_SELECTABLE_NODES = {
  "TIME_SWITCH": NODES.TIME_SWITCH,
  "OPENING_TIME": NODES.OPENING_TIME,
  "TTS_ANNOUNCE": NODES.TTS_ANNOUNCE,
  "FILE_ANNOUNCE": NODES.FILE_ANNOUNCE,
  "SMART_GREETING": NODES.SMART_GREETING,
  "RECORD": NODES.RECORD,
  "IVR": NODES.IVR,
  "DIAL": NODES.DIAL,
  "ADD_LABEL": NODES.ADD_LABEL,
  "HANGUP": NODES.HANGUP,
  "LIST_ROUTING": NODES.LIST_ROUTING,
  "MARK_AS_ANSWERED": NODES.MARK_AS_ANSWERED,
  "WEBHOOK": NODES.WEBHOOK,
  "WEBHOOK_ROUTING": NODES.WEBHOOK_ROUTING,
};

export function DialplanNodeSelection() {
  const [open, setState] = useState(false);
  const { node, setNode } = useDialplanNodeContext();
  const { data: profile } = useProfile();

  const SELECTABLE_NODES = useMemo(() => {
    const enabled = { ...BASE_SELECTABLE_NODES };
    const experimental = profile?.experimentalDialplanNodes ?? [];
    if (experimental.includes('AGENT')) {
      enabled['AGENT'] = NODES.AGENT;
    } else if (experimental.includes('AGENT_BRING_YOUR_OWN')) {
      enabled['AGENT'] = AgentBringYourOwnVariant;
    }
    if (experimental.includes('SEND_WHATSAPP')) {
      enabled['SEND_WHATSAPP'] = NODES.SEND_WHATSAPP;
    }
    return enabled;
  }, [profile?.experimentalDialplanNodes]);

  const isAdvanced = node && SELECTABLE_NODES[node.type]?.isAdvanced === true;
  const [selectedType, setSelectedType] = useState(node?.type);
  const [selectedAdvanced, setSelectedAdvanced] = useState(isAdvanced);

  useEffect(() => {
    if (open) {
      setSelectedType(node?.type);
      setSelectedAdvanced(isAdvanced);
    }
  }, [open, node?.type, isAdvanced]);

  return <Stack direction="row" justifyContent={!node ? "center" : "flex-end"} sx={{mb:2}}>
    <Button color="primary" variant="outlined"
            onClick={() => setState(true)}>{node ? "MODIFICA COMPORTAMENTO" : "AGGIUNGI COMPORTAMENTO"}</Button>
    <Dialog
      open={open}
      onClose={() => setState(false)}
      fullWidth={true}
      maxWidth="sm">
      <DialogTitle>Scegli comportamento</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Seleziona una tipologia di comporamento
        </DialogContentText>
        <FormControl fullWidth={true}>
          <Typography variant="body1" sx={{ mt: 3 }}>
            Comportamento
          </Typography>
          <Select
            value={selectedType || node?.type}
            onChange={e => {
              const type = e.target.value;
              setSelectedType(type);

              const isNewNodeAdvanced = SELECTABLE_NODES[type]?.isAdvanced === true;
              setSelectedAdvanced(isNewNodeAdvanced);

              if (type !== node?.type && !isNewNodeAdvanced) {
                setNode(SELECTABLE_NODES[type]?.default);
                setState(false);
              }
            }}
            sx={selectedAdvanced ? {
              background: 'linear-gradient(90deg, rgba(255,236,210,1) 0%, rgba(252,182,159,1) 100%)',
            } : {}}
          >
            {Object.values(SELECTABLE_NODES).map(n =>
              <MenuItem
                key={n.default?.type}
                value={n.default?.type}
                sx={n.isAdvanced ? {
                  background: 'linear-gradient(90deg, rgba(255,236,210,1) 0%, rgba(252,182,159,1) 100%)',
                  fontWeight: 'bold'
                } : {}}
              >
                {n?.title} {n.isAdvanced ? " (Funzione avanzata)" : ""}
              </MenuItem>
            )}
          </Select>
          {selectedAdvanced && (
            <>
              <Alert severity="warning" sx={{ mt: 2 }}>
                <Typography variant="body2" fontWeight="medium">
                  Questa è una funzione avanzata. Se hai bisogno di assistenza nella configurazione, contatta il supporto tecnico.
                </Typography>
              </Alert>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => {
                  setNode(SELECTABLE_NODES[selectedType]?.default);
                  setState(false);
                }}
              >
                Conferma selezione
              </Button>
            </>
          )}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setState(false)}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  </Stack>;
}
